import { Axios } from "../httpService";

export const getListAcm = () => {
  return Axios.get("/Info/ListAcm");
};
export const getRules = () => {
  return Axios.get("/Info/ListGhavaninCopysa");
};
export const getAuthRules = () => {
  return Axios.get("/Info/ListGhavaninRegister");
};
export const getContactUs = () => {
  return Axios.get("/Info/ContactUs");
};

export const addSuggest = (data) => {
  return Axios.post("/Info/AddSuggest", data, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

